export default __webpack_public_path__ + "static/media/img-legal-2.645ec761.png";